module.exports = __webpack_public_path__ + "static/media/startup-tnt-logo.f2c5f671.png";